import { useState, useCallback } from "react";

import { getSelectedUsers } from "api/users";

export const useUsersData = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 25,
  });

  const fetchUsers = useCallback(async (filters = {}, searchTerm = "", page = 1, perPage = 25) => {
    try {
      setLoading(true);

      const params = {
        ...filters,
        q: searchTerm,
        page,
        per_page: perPage,
      };

      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });

      const response = await getSelectedUsers(params);

      if (response.success && response.users?.data?.length > 0) {
        const updatedUsers = response.users.data.map((user) => ({
          ...user,
          shift_time: user.shift ? `${user.shift.start_time} - ${user.shift.end_time}` : "-",
        }));

        setUsers(updatedUsers);
        setPagination({
          total: response.users.total,
          current_page: response.users.current_page,
          last_page: response.users.last_page,
          per_page: response.users.per_page,
        });
      } else {
        // Handle no users found or unsuccessful response
        setUsers([]); // Clear user list
        setPagination({
          total: 0,
          current_page: 1,
          last_page: 1,
          per_page: perPage,
        });
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]); // Optional: clear on error
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    users,
    loading,
    pagination,
    fetchUsers,
    setPagination,
  };
};
